import { render } from "./BauflaechenFooter.vue?vue&type=template&id=f66b3b08&scoped=true&ts=true"
import script from "./BauflaechenFooter.vue?vue&type=script&lang=ts"
export * from "./BauflaechenFooter.vue?vue&type=script&lang=ts"

import "./BauflaechenFooter.vue?vue&type=style&index=0&id=f66b3b08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66b3b08"]])

export default __exports__